var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    staticClass: "pl-0 py-0 pt-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', _vm._b({
    ref: "dayRef",
    attrs: {
      "placeholder": "DD",
      "label": "Dag",
      "maxlength": "2"
    },
    on: {
      "keypress": function keypress($event) {
        return _vm.isNumber($event);
      },
      "input": _vm.emitChanges
    },
    model: {
      value: _vm.day,
      callback: function callback($$v) {
        _vm.day = $$v;
      },
      expression: "day"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs), false))], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', _vm._b({
    ref: "monthRef",
    attrs: {
      "outlined": "",
      "label": "Måned",
      "placeholder": "MM",
      "maxlength": "2"
    },
    on: {
      "input": _vm.emitChanges,
      "keypress": function keypress($event) {
        return _vm.isNumber($event);
      }
    },
    model: {
      value: _vm.month,
      callback: function callback($$v) {
        _vm.month = $$v;
      },
      expression: "month"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs), false))], 1), _c('v-col', {
    staticClass: "pr-0 py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', _vm._b({
    ref: "yearRef",
    attrs: {
      "label": "År",
      "placeholder": "ÅÅ",
      "outlined": "",
      "maxlength": "4",
      "rules": [].concat(_vm.validateParticipantMaxAge, _vm.validateParticipantMinAge)
    },
    on: {
      "keypress": function keypress($event) {
        return _vm.isNumber($event);
      },
      "input": _vm.emitChanges
    },
    model: {
      value: _vm.year,
      callback: function callback($$v) {
        _vm.year = $$v;
      },
      expression: "year"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs), false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }